import { useAutocomplete } from "./providers/AutocompleteProvider.tsx";
import { SearchFieldInitial } from "./components/SearchFieldInitial.tsx";
import { Modal } from "./components/Modal.tsx";
import { Form } from "./components/Form.tsx";
import { Categories } from "./components/Categories.tsx";
import { Products } from "./components/Products.tsx";

export function AppAutocomplete() {
	const { autocomplete, searchRef, panelRef } = useAutocomplete();
	return (
		<div className={`aa-autocomplete`} {...autocomplete.getRootProps({})}>
			<SearchFieldInitial />
			<Modal>
				<div className={"aa-autocomplete__layout"}>
					<header className={"aa-autocomplete__header"}>
						<div className={"aa-autocomplete__logo"}>
							<img alt="Aurednik logo" loading={"lazy"} width={186} height={34} src="/userdata/images/logos/aurednik-algolia-header-logo.svg" />
						</div>
						<div className={"aa-autocomplete__controls"}>
							<Form />
							{/*isModalOpen && <Filter/>*/}
						</div>
					</header>
					<section className="aa-PanelLayout aa-autocomplete__content" ref={panelRef} {...autocomplete.getPanelProps({})}>
						<aside className="aa-autocomplete__side">
							<Categories />
						</aside>
						<div className="aa-autocomplete__results" ref={searchRef}>
							<Products />
						</div>
					</section>
				</div>
			</Modal>
		</div>
	);
}
